const initialState = {
	open: false,
	current: null,
	submenus: [],
	fetched: false,
};

const menuReducer = (state=initialState, action) => {
	switch (action.type) {
		case 'FETCH_CONFIG_SUCCESS':
			{
				const years = action.payload.data.years;
				const categories = action.payload.data.categories;
				let items = [];

				if ( years ) items.push({ 
					slug: 'years',
					title: 'Year',
					items: years
				});
				
				if ( categories ) items.push({ 
					slug: 'categories',
					title: 'Category',
					items: categories 
				});
				
				items.push({ 
					slug: 'works',
					title: 'All' 
				});
				
				return {...state, submenus: items, fetched: true };
			}
		
		case 'MENU_ENTER':
			return { ...state, open: true };

		case 'MENU_SET_ACTIVE':
			return { ...state, current: action.slug }

		case 'MENU_EXIT':
			return { ...state, current: null, open: false }

		case 'SHOW_SITE_INTRO':
			return { ...state, current: null, open: false }

		default:
			return state;
	}
}

export default menuReducer;


// WEBPACK FOOTER //
// ./src/reducers/menu.jsx